import {db} from '@/firebase'
import EventEmitter from 'events'
import { store } from '@/store'

// Extend EventEmitter so user of CountryRepository can react to our own defined events. (ex: countryRepository.on('added'))
class CountryRepository extends EventEmitter {
    constructor () {
        super()

        this.collection = db.collection('countries')

        return this
    }

    // Check if a Country exists
    list (onSuccess, onError) {
        this.collection.get()
            .then((querySnapshot) => {
                let countries = {}

                querySnapshot.forEach((doc) => {
                    countries[doc.id] = doc.data()
                });

                onSuccess(countries)
            })
            .catch((error) => {
                onError(error)
            })
    }
}

export default new CountryRepository()


// WEBPACK FOOTER //
// ./src/data/CountryRepository.js